// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const VideoOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 576 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M336.2 64H47.8A47.8 47.8 0 000 111.8v288.4A47.8 47.8 0 0047.8 448h288.4a47.8 47.8 0 0047.8-47.8V111.8A47.8 47.8 0 00336.2 64zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z","fill":"currentColor"}}]},"name":"video","theme":"outlined"};

const VideoOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={VideoOutlinedSvg} />;
  VideoOutlined.displayName = 'VideoOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(VideoOutlined);
